/* global jQuery */

import Typed from 'typed.js';

( function( $ ) {

//Shrink nav after scroll
  // When the user scrolls the page, execute scrollShrinkNav 
  window.onscroll = function() {scrollShrinkNav()};

  // Get the navbar
  var navbar = $(".c-header");

  // Get the offset position of the navbar
  var shrink = navbar.offset().top;

  // Add the shrink class to the navbar when you reach its scroll position. Remove "shrink" when you leave the scroll position
  function scrollShrinkNav() {
    if (window.pageYOffset > shrink) {
      navbar.addClass("shrink");

    } else {
      navbar.removeClass("shrink");
    }
}

} )( jQuery )



// WEBPACK FOOTER //
// ./src/js/inc/shrink-nav.js